exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-6969ee22]{background-color:#f5f4e8 !important\n}\n.btn-primary.disabled[data-v-6969ee22],.btn-primary[data-v-6969ee22]:disabled{color:#fff;background-color:#00c8f8 !important;border-color:#00c8f8 !important;opacity:1 !important\n}\n.btn-primary.disabled[data-v-6969ee22]:hover,.btn-primary[data-v-6969ee22]:disabled:hover{color:#fff;background-color:#879649 !important;border-color:#879649 !important;opacity:1 !important\n}\n.ResetPassword[data-v-6969ee22]{width:160px !important;margin-left:auto !important;margin-right:auto !important;font-weight:bold !important\n}", ""]);

// exports
